import { render, staticRenderFns } from "./shichangshixunjianyi.vue?vue&type=template&id=6500cfbc&scoped=true"
import script from "./shichangshixunjianyi.vue?vue&type=script&lang=js"
export * from "./shichangshixunjianyi.vue?vue&type=script&lang=js"
import style0 from "./shichangshixunjianyi.vue?vue&type=style&index=0&id=6500cfbc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6500cfbc",
  null
  
)

export default component.exports